module.exports = __webpack_public_path__ + "img/main.f5d38722.jpg";